import React from 'react';
import BlogItem from '../components/BlogItem/BlogItem';
import Header from '../components/Header/Header';

const Blog = () => {
    return (
        <>
            <Header />
            <BlogItem />
        </>
    );
};

export default Blog;